import * as React from "react";
import { ArrowRight, Book, Coffee } from "lucide-react";
import CoffeeGridBoxes from "../components/Coffee/CoffeeGridBoxes";
import BooksHome from "../components/Books/BooksHome";

const HomePage = () => {
  return (
    <main className="min-h-screen pt-24">
      {/* Hero Section */}
      <section className="page-container">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 space-y-6">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-foreground tracking-tight leading-tight">
              Hi, I&apos;m Erick Chandra.
            </h1>
            <p className="text-lg sm:text-xl text-muted leading-relaxed">
              A tech professional based in Singapore, with expertise in software engineering, artificial intelligence, and data. SUTD Computer Science Class of 2024.
            </p>
           
            <p className="text-muted leading-relaxed">
              During weekdays evening and weekends, I enjoy spending time on learning and creating side projects across multidisciplinary topics. I also have a deep passion for photography, brewing specialty coffee, personal investing, playing basketball, cooking, and visiting libraries or exhibitions.
            </p>
             <p className="text-muted leading-relaxed">
              I see my life as a portfolio of projects including work, serious passions, and social life — and I am the project manager of all of them.
            </p>
            <a
              href="/about"
              className="inline-flex items-center gap-2 text-foreground hover:text-muted transition-colors duration-200 group"
            >
              Learn more about me
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" />
            </a>
          </div>
          <div className="flex-shrink-0">
            <img
              className="w-72 h-72 lg:w-80 lg:h-80 object-cover rounded-lg"
              alt="Erick Chandra"
              src="https://storage.googleapis.com/erc-photos/home/profileBali.jpg"
            />
          </div>
        </div>
      </section>

      {/* Currently Section */}
      <section className="page-container border-t border-border mt-16 pt-16">
        <h2 className="section-title mb-8">Currently</h2>
        <div className="grid md:grid-cols-2 gap-8">
          {/* Currently Reading */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-muted">
              <Book size={18} />
              <span className="text-sm font-medium uppercase tracking-wider">Reading</span>
            </div>
            <BooksHome
              title="The Hidden Wealth of Nations"
              writer="Gabriel Zucman"
              pages=""
              pict="https://storage.googleapis.com/erc-photos/books/theHiddenWealthOfANation.jpeg"
            />
            <a
              href="/books"
              className="inline-flex items-center gap-2 text-sm text-muted hover:text-foreground transition-colors duration-200"
            >
              View all books
              <ArrowRight size={14} />
            </a>
          </div>

          {/* Currently Brewing */}
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-muted">
              <Coffee size={18} />
              <span className="text-sm font-medium uppercase tracking-wider">Brewing</span>
            </div>
            <CoffeeGridBoxes
              beansName="Mount Prau Black Honey, Central Java"
              roaster="Space Roastery, Yogyakarta, Indonesia"
              tastingnotes="Hybrid Honey Triple Yeast Mossto process, best for filter"
              beanspicture="https://storage.googleapis.com/erc-photos/coffee/home-brew/SpaceRoasteryPrauBlackHoney.jpg"
            />
            <a
              href="/coffee"
              className="inline-flex items-center gap-2 text-sm text-muted hover:text-foreground transition-colors duration-200"
            >
              View all coffee
              <ArrowRight size={14} />
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
